import { useMemo } from 'react'

import { useAuth } from '@sputnik/auth'

import { useGetApplicationEmails } from './GetApplicationEmails.gql'
import { type CollaboratorData, UseApplicationCollaboratorsParams } from './types'
import { getAllCollaborators, getCollaboratorsOnCreditApplication } from './utils'

const useApplicationCollaborators = ({ salesforceCreditId, skip }: UseApplicationCollaboratorsParams) => {
  const { email } = useAuth()

  const { data, loading } = useGetApplicationEmails({
    variables: {
      creditApplicationId: salesforceCreditId,
    },
    skip,
  })

  const collaboratorsOnCreditApplication = useMemo(() => {
    if (!email || loading || !data?.creditApplication) {
      return new Map<string, CollaboratorData>()
    }

    return getCollaboratorsOnCreditApplication(data.creditApplication)
  }, [data, email, loading])

  const allCollaborators = useMemo(() => {
    if (!email || loading || !data?.creditApplication) {
      return []
    }

    return getAllCollaborators({ collaboratorsOnCreditApplication, email, creditApplication: data.creditApplication })
  }, [collaboratorsOnCreditApplication, data, email, loading])

  return { collaboratorsOnCreditApplication, allCollaborators, isLoadingApplicationCollaborators: loading }
}

export default useApplicationCollaborators
